/**
 * ============================================================================
 * GET PERMISSIONS API — accessor for POST /getPermissions.
 * ============================================================================
 *
 * LAYER: accessor. The caller's access profile: every served dashboard,
 * feature, and operation category with an accessible flag and the gating
 * Bindle Lock. Constant for a session, so callers fetch it once
 * (permissionsApi). The UI describes ITSELF: actorId = the Mons-injected
 * Midway alias, actorType = "principal" — the server overrides Midway
 * callers to their authenticated alias anyway (the client value is a hint).
 */

import { ReportingApiClient } from 'src/accessors/ReportingApiClient';
import {
  GetPermissionsInput,
  GetPermissionsOutput,
} from 'src/types/permissionsApi.types';

class GetPermissionsApiClient extends ReportingApiClient {
  public async getPermissions(
    input: GetPermissionsInput,
  ): Promise<GetPermissionsOutput> {
    return this.post<GetPermissionsOutput>('/getPermissions', input);
  }
}

/** Singleton (portal convention): one shared instance app-wide. */
export const GetPermissionsApi = new GetPermissionsApiClient();
